import React, {useMemo} from 'react';
import AdmicityTabs from '../../../../shared-components/AdmicityTabs';
import Lookups from './Lookups';
import AdmicityLookups from './AdmicityLookups';

const LookupsTabs = () => {
    const tabs = useMemo(() => [
        {
            label: 'SIMS Lookups',
            component: <Lookups/>
        },
        {
            label: 'Admicity Lookups',
            component: <AdmicityLookups/>
        }
    ], []);

    return <AdmicityTabs tabs={tabs} displayDivider/>;
};

export default LookupsTabs;
